import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=001bfd08&scoped=true&"
import script from "./SectionTitle.vue?vue&type=script&lang=js&"
export * from "./SectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=001bfd08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001bfd08",
  null
  
)

export default component.exports